export class BrandLogo {
	logoType: string;
	logoPath: string;
}
